import { useState } from "react";
import ImageBanner from "@/components/ImageBanner";
import Footer from "@/layout/Footer";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import DesktopForgotPasswordForm from "@/components/DesktopForgotPasswordForm";
import MobileForgotPasswordForm from "@/components/MobileForgotPasswordForm";
import UseHandleBack from "@/hooks/UseHandleBack";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authAction } from "@/redux/actions/auth.action";

const schema = Yup.object().shape({
	email: Yup.string().email("Invalid email").required("Email is required"),
});
const ForgotPassword = () => {
	const handleBack = UseHandleBack("/");
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [forgotPasswordError, setForgotPasswordError] = useState(null);

	const desktopForm = useForm({
		resolver: yupResolver(schema),
	});
	const mobileForm = useForm({
		resolver: yupResolver(schema),
	});

	const onSubmit = async (data) => {
		try {
			const result = await dispatch(authAction.forgotPassword(data));
			console.log("Forgot Password Result:", result);
			if (result?.success) {
				navigate("/verify-otp");
			} else {
				setForgotPasswordError(result?.error || "Login failed");
			}
		} catch (error) {
			console.error("Forgot Password failed:", error);
			setForgotPasswordError(
				error?.error || error.message || "An unexpected error occurred"
			);
		}
	};
	return (
		<>
			<div className="relative flex flex-col hidden lg:flex w-full h-auto items-center justify-center mt-[40px]">
				<div className="w-full max-w-[1440px] flex items-center justify-between px-8">
					<ImageBanner
						type="desktop"
						title="Forgot Password"
						containerWidth="w-full max-w-[1440px] flex items-center"
						titlePosition={{ top: "top-[100px]", left: "left-[60px]" }}
					/>
				</div>
			</div>
			<div className="flex justify-center mt-[28px] h-[700px] hidden lg:flex">
				<div className="w-[361px] h-auto flex flex-col items-center gap-[16px] rounded-[8px] pt-[16px] pr-[20px] pb-[32px] pl-[20px]">
					{forgotPasswordError && (
						<div className="text-red-500 text-sm mb-4">
							{forgotPasswordError}
						</div>
					)}
					<DesktopForgotPasswordForm
						register={desktopForm.register}
						errors={desktopForm.formState.errors}
						handleSubmit={desktopForm.handleSubmit}
						onSubmit={onSubmit}
					/>
					<p
						className="text-[14px] font-[400] font-montserrat leading-[1] text-[#193D34] cursor-pointer"
						onClick={handleBack}
					>
						Back
					</p>
				</div>
			</div>
			{/* Mobile View  */}
			<ImageBanner type="mobile" title="Forgot Password" />
			<div className="flex justify-center mt-[28px] h-[490px] lg:hidden">
				<div className="w-[95%] max-w-[361px] flex flex-col items-center gap-[16px] rounded-[8px] pt-[16px] pr-[20px] pb-[32px] pl-[20px]">
					{forgotPasswordError && (
						<div className="text-red-500 text-sm mb-4">
							{forgotPasswordError}
						</div>
					)}
					<MobileForgotPasswordForm form={mobileForm} onSubmit={onSubmit} />
					<p
						className="text-[14px] font-[400] font-montserrat leading-[1] text-[#193D34] cursor-pointer"
						onClick={handleBack}
					>
						Back
					</p>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default ForgotPassword;
